/**
 * Stažení tabulek: PDF (přes tisk), CSV a Excel (.xlsx).
 */
import { noFormula } from '../lib/dates';
import { xlsx, type Cell } from '../lib/xlsx';
import { Icon } from './icons';

export interface Table {
  /** Název souboru bez přípony. */
  name: string;
  head: string[];
  rows: Cell[][];
}

/** Název souboru bez diakritiky a mezer – některé prohlížeče jinak soubor pojmenují jen „download“. */
const safe = (s: string) =>
  s
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .replace(/[^A-Za-z0-9_-]+/g, '-')
    .replace(/-+/g, '-')
    .replace(/^-|-$/g, '')
    .toLowerCase() || 'export';

function save(filename: string, data: BlobPart, type: string) {
  const url = URL.createObjectURL(new Blob([data], { type }));
  const a = document.createElement('a');
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  a.remove();
  setTimeout(() => URL.revokeObjectURL(url), 2000);
}

export function toCsv(t: Table): string {
  const cell = (v: Cell) => {
    if (v == null) return '""';
    const s = typeof v === 'number' ? String(v).replace('.', ',') : noFormula(String(v));
    return `"${s.replace(/"/g, '""')}"`;
  };
  return [t.head, ...t.rows].map((r) => r.map(cell).join(';')).join('\r\n');
}

export function downloadCsv(t: Table) {
  save(`${safe(t.name)}.csv`, '﻿' + toCsv(t), 'text/csv;charset=utf-8');
}

export function downloadXlsx(t: Table) {
  const bytes = xlsx(t.name, t.head, t.rows);
  save(`${safe(t.name)}.xlsx`, bytes as BlobPart, 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet');
}

/** Tlačítka Tisk / PDF, Excel a CSV. Bez tabulky jen tisk. */
export function ExportButtons({ table }: { table?: Table | null }) {
  return (
    <div className="quick-row no-print export-row">
      <button className="btn" onClick={() => window.print()}>
        <Icon name="print" size={20} /> Tisk / PDF
      </button>
      {table && table.rows.length > 0 && (
        <>
          <button className="btn" onClick={() => downloadXlsx(table)}>
            <Icon name="table" size={20} /> Excel
          </button>
          <button className="btn" onClick={() => downloadCsv(table)}>
            CSV
          </button>
        </>
      )}
    </div>
  );
}
